import { render } from "./ProductMeasurements.vue?vue&type=template&id=ed81741e&scoped=true"
import script from "./ProductMeasurements.vue?vue&type=script&lang=js"
export * from "./ProductMeasurements.vue?vue&type=script&lang=js"

import "./ProductMeasurements.vue?vue&type=style&index=0&id=ed81741e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed81741e"]])

export default __exports__